<app-navbar customHeader="true">
  <div class="container-fluid bg-light mh-100">
    <div class="row d-flex justify-content-center col-12">
      <app-selecao-tipo-usuario *ngIf="!hasForm" (tipoSelecionado)="onTipoSelecionado($event)" (voltar)="backStep()"></app-selecao-tipo-usuario>
      <app-cadastro-usuario *ngIf="hasForm" [typeForm]="typeForm" (voltar)="onVoltar()"></app-cadastro-usuario>
    </div>
  </div>
</app-navbar>
<footer class="page-footer font-small custom-bg-color">
  <div class="footer-copyright text-center py-3 custom-footer">© {{currentYear}} Fundo Garantidor de Créditos - FGC. Todos os direitos reservados.</div>
</footer>
